import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { RoutesPaths } from "./constant";

function PrivateRoute({ children }) {
  const isLogin = localStorage.getItem("authToken") || null;
  if (!isLogin) {
    return <Navigate to={RoutesPaths.LOGIN} />;
  }
  return children;
}

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
